export default function Logo({ size = 32 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 200 200" fill="none" aria-hidden="true">
      <rect width="200" height="200" rx="40" fill="#FFCF31" />
      <circle cx="88" cy="88" r="44" stroke="#331E6D" strokeWidth="6" fill="none" />
      <line
        x1="121"
        y1="121"
        x2="158"
        y2="158"
        stroke="#331E6D"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <circle cx="88" cy="76" r="11" stroke="#331E6D" strokeWidth="4" fill="none" />
      <path
        d="M 66 110 Q 66 92 88 92 Q 110 92 110 110 Z"
        stroke="#331E6D"
        strokeWidth="4"
        fill="none"
        strokeLinejoin="round"
      />
    </svg>
  );
}
